import React from 'react';
import { useSendEvent } from './useSendEvent';

interface SendEventProps {
  sendEvent: (data: any) => void;
}

type SendEventHOC = <T extends SendEventProps>(Component: React.ComponentType<T>) => React.FC<T>;

export const sendEventHOC: SendEventHOC = Component => {
  return function AnalyticsTracker(props) {
    const { sendEvent } = useSendEvent();

    return <Component {...props} sendEvent={sendEvent} />;
  };
};
